// Mock data for YDD.News landing page (frontend-only teaser)

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'News', href: '#news' },
  { label: 'Rewards', href: '#rewards' },
  { label: 'How it Works', href: '#how' },
  { label: 'Reviews', href: '#reviews' },
];

export const heroStats = [
  { value: '10K+', label: 'Downloads' },
  { value: '4.6', label: 'Play Store Rating' },
  { value: '50+', label: 'Brand Rewards' },
];

// Live-ticker breaking headlines
export const tickerHeadlines = [
  'Sensex hits fresh record high as IT stocks rally',
  'India clinch thriller by 4 wickets in final over',
  'New AI model breaks benchmarks across the board',
  'Monsoon arrives early across the west coast',
  'Blockbuster OTT release tops charts in 24 hours',
  'Startup funding rebounds in Q3 with mega rounds',
];

export const newsCategories = [
  {
    tag: 'Breaking',
    title: 'Ramcharan & Sukumar pair up for RC17',
    summary: 'Mythri Movie Makers announce their next project directed by Sukumar. Details kept under wraps.',
    img: 'https://images.unsplash.com/photo-1742805382149-3c2f0cd0f300?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxicmVha2luZyUyMG5ld3N8ZW58MHx8fHwxNzg5NjU4ODQxfDA&ixlib=rb-4.1.0&q=85',
    points: 5,
  },
  {
    tag: 'Sports',
    title: 'Cricketer Siraj reports for duty as DSP',
    summary: 'The pacer joins the Telangana police force as Deputy Superintendent in a special ceremony.',
    img: 'https://images.unsplash.com/photo-1730739463889-34c7279277a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwzfHxjcmlja2V0JTIwc3RhZGl1bXxlbnwwfHx8fDE3ODk2NTg4NDF8MA&ixlib=rb-4.1.0&q=85',
    points: 4,
  },
  {
    tag: 'Business',
    title: 'Markets close at all-time high on IT rally',
    summary: 'Benchmark indices surged over 1.2% led by heavyweight technology and banking counters.',
    img: 'https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxzdG9jayUyMG1hcmtldHxlbnwwfHx8fDE3ODk2NTg4NDF8MA&ixlib=rb-4.1.0&q=85',
    points: 5,
  },
  {
    tag: 'Technology',
    title: 'New flagship chip promises 2x battery life',
    summary: 'The next-gen mobile processor focuses on on-device AI and dramatic efficiency gains.',
    img: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHx0ZWNobm9sb2d5fGVufDB8fHx8MTc4OTY1ODg0MXww&ixlib=rb-4.1.0&q=85',
    points: 4,
  },
  {
    tag: 'Travel',
    title: 'Hidden coastal towns you must visit this year',
    summary: 'From quiet beaches to buzzing markets, these getaways are trending with young travellers.',
    img: 'https://images.unsplash.com/photo-1614088459293-5669fadc3448?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHx0cmF2ZWwlMjBkZXN0aW5hdGlvbnxlbnwwfHx8fDE3ODk2NTg4NDF8MA&ixlib=rb-4.1.0&q=85',
    points: 3,
  },
  {
    tag: 'Entertainment',
    title: 'Weekend box office roars back to life',
    summary: 'Two big releases drove footfalls to multiplexes with record advance bookings.',
    img: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjaW5lbWF8ZW58MHx8fHwxNzg5NjU4ODQxfDA&ixlib=rb-4.1.0&q=85',
    points: 4,
  },
];

import { Newspaper, Trophy, Landmark, Cpu, Plane, Film, HeartPulse, Car, Sparkles, Beaker } from 'lucide-react';

export const categoryChips = [
  { label: 'Breaking News', icon: Newspaper },
  { label: 'Sports', icon: Trophy },
  { label: 'Business & Finance', icon: Landmark },
  { label: 'Technology', icon: Cpu },
  { label: 'Travel', icon: Plane },
  { label: 'Entertainment', icon: Film },
  { label: 'Health', icon: HeartPulse },
  { label: 'Auto', icon: Car },
  { label: 'Lifestyle', icon: Sparkles },
  { label: 'Science', icon: Beaker },
];

import { ShoppingBag, Utensils, Coffee, Clapperboard, Shirt, Smartphone } from 'lucide-react';

export const rewardBrands = [
  { label: 'Shopping', icon: ShoppingBag, offer: 'Up to 40% off', img: 'https://images.unsplash.com/photo-1563013544-824ae1b704d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxvbmxpbmUlMjBzaG9wcGluZ3xlbnwwfHx8fDE3ODk2NTg4Nzh8MA&ixlib=rb-4.1.0&q=85' },
  { label: 'Food Delivery', icon: Utensils, offer: 'Flat ₹120 off', img: 'https://images.pexels.com/photos/9461653/pexels-photo-9461653.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { label: 'Restaurants & Cafes', icon: Coffee, offer: 'Buy 1 Get 1', img: 'https://images.pexels.com/photos/5868278/pexels-photo-5868278.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940' },
  { label: 'Entertainment', icon: Clapperboard, offer: '2 months free', img: 'https://images.unsplash.com/photo-1536440136628-849c177e76a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxjaW5lbWF8ZW58MHx8fHwxNzg5NjU4ODQxfDA&ixlib=rb-4.1.0&q=85' },
  { label: 'Fashion', icon: Shirt, offer: 'Extra 25% off', img: 'https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwc2hvcHBpbmd8ZW58MHx8fHwxNzg5NjU4ODc4fDA&ixlib=rb-4.1.0&q=85' },
  { label: 'Electronics', icon: Smartphone, offer: 'Save ₹2000', img: 'https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHx0ZWNobm9sb2d5fGVufDB8fHx8MTc4OTY1ODg0MXww&ixlib=rb-4.1.0&q=85' },
];

import { BookOpenCheck, Coins, Ticket } from 'lucide-react';

export const howItWorks = [
  { step: '01', title: 'Read the News', desc: 'Skim short, easy-to-read stories across all your favourite categories in minutes.', icon: BookOpenCheck },
  { step: '02', title: 'Earn Points', desc: 'Every article you read adds reward points to your wallet. The more you read, the more you earn.', icon: Coins },
  { step: '03', title: 'Redeem & Save', desc: 'Convert points into exclusive discounts and offers from Indias leading brands.', icon: Ticket },
];

import { Zap, Moon, Bell, Heart, Share2, LayoutGrid } from 'lucide-react';

export const appFeatures = [
  { title: 'Short & simple stories', desc: 'Bite-sized news you can finish on the go.', icon: Zap },
  { title: 'Clean reading interface', desc: 'A distraction-free, lightweight experience.', icon: Moon },
  { title: 'Instant breaking alerts', desc: 'Be the first to know when it matters.', icon: Bell },
  { title: 'Save your favourites', desc: 'Bookmark stories to read anytime, anywhere.', icon: Heart },
  { title: 'Share in a tap', desc: 'Send stories to friends and family instantly.', icon: Share2 },
  { title: 'Personalized feed', desc: 'Stories tailored to what you love.', icon: LayoutGrid },
];

export const testimonials = [
  {
    name: 'Aarav Mehta',
    role: 'Daily Reader, Mumbai',
    quote: 'Quick updates that keep me informed about everything happening around the world. And I actually save money every week!',
    avatar: 'https://i.pravatar.cc/120?img=12',
    rating: 5,
  },
  {
    name: 'Priya Nair',
    role: 'Student, Bengaluru',
    quote: 'Bite-sized news makes it easy to stay updated on my favourite topics. Redeeming points for food coupons is the best part!',
    avatar: 'https://i.pravatar.cc/120?img=45',
    rating: 5,
  },
  {
    name: 'Rohan Kapoor',
    role: 'Frequent Traveller, Delhi',
    quote: 'As a globetrotter, I appreciate the diverse news categories. Perfect for my on-the-go lifestyle and the travel rewards are great.',
    avatar: 'https://i.pravatar.cc/120?img=33',
    rating: 5,
  },
];

export const footerLinks = {
  Product: ['News Feed', 'Rewards', 'Categories', 'Notifications'],
  Company: ['About Us', 'Careers', 'Press', 'Contact'],
  Legal: ['Privacy Policy', 'Terms of Use', 'Data Safety', 'Cookies'],
};
